import { FC, forwardRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useMessageContext } from 'stream-chat-react';
import { EyeOffLine, Theme, Text } from '@bizzabo/design-system';
import { Timestamp, UserBadge } from '@bizzabo/collaboration-common';

interface IMessageFailedProps {
    showUserPopup?: ({
        id,
        avatarRef,
    }: {
        id: string;
        avatarRef: typeof forwardRef | undefined | null;
    }) => void;
}

const MessageFailed: FC<IMessageFailedProps> = ({ showUserPopup }) => {
    const classes = useStyles();
    const { message } = useMessageContext();
    return (
        <div>
            <div className={classes.failedMessageContainer}>
                <EyeOffLine width={16} height={16} />
                <Text variant="t81" className={classes.failedMessageContent}>
                    This thread has been deactivated by the host
                </Text>
            </div>
            <UserBadge
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                user={message.user}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                showUserPopup={showUserPopup}
                nameSibling={<Timestamp startTime={message.created_at} withDot />}
            />
        </div>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        failedMessageContainer: {
            display: 'flex',
            color: theme.palette.greys['500'],
            marginBottom: 8,
        },
        failedMessageContent: { color: theme.palette.greys['500'], marginLeft: 4 },
    }),
    {
        classNamePrefix: MessageFailed.name,
    }
);

export default MessageFailed;
